import CondenseIconMark from "./CondenseIconMark";

const GREEN = "#18D889";

export default function CondenseLogo({
  height = 28,
  className = "",
  color = "currentColor",
  showWordmark = true,
}) {
  const iconSize = Math.max(16, Math.round(height * 0.72));

  return (
    <span
      className={`condense-logo ${className}`}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: Math.max(6, Math.round(height * 0.22)),
        color,
      }}
    >
      <CondenseIconMark size={iconSize} />
      {showWordmark ? (
        <span
          style={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 600,
            fontSize: Math.max(14, Math.round(height * 0.5)),
            letterSpacing: "-0.02em",
            color: "currentColor",
            lineHeight: 1,
            whiteSpace: "nowrap",
          }}
        >
          Condense
          <span style={{ color: GREEN }}>.tv</span>
        </span>
      ) : null}
    </span>
  );
}
